export default __webpack_public_path__ + "20260730_Abbildung Antragsseite CB Raeder & Reifen.png";